// extracted by mini-css-extract-plugin
module.exports = {"container":"paidjoinError_container__1md5d","title":"paidjoinError_title__1A0_y","read":"paidjoinError_read__2nYZZ","button":"paidjoinError_button__1w5PO"};